import Category from "../Category";
import MenuItemBuilder from "../MenuItemBuilder";
import {addOnOptions} from "../AddOnOptions";

export default new Category('Combination Platters', 'images/categories/combo.jpg')
    .setDescription('Each Platter Served w/ An Egg Roll, White Rice or Fried Rice')
    .addMenuItem(new MenuItemBuilder('Chicken or Pork Lo Mein (Combo Platter)', 8.29)
        .setOptions('Chicken Lo Mein (Combo Platter)', 'Pork Lo Mein (Combo Platter)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp or Beef Lo Mein (Combo Platter)', 8.29)
        .setOptions('Shrimp Lo Mein (Combo Platter)', 'Beef Lo Mein (Combo Platter)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sweet & Sour Chicken or Pork (Combo Platter)', 8.29)
        .setOptions('Sweet & Sour Chicken (Combo Platter)', 'Sweet & Sour Pork (Combo Platter)')
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Moo Goo Gai Pan (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Broccoli (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Mixed Vegetable (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Cashew Nuts (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Chicken w/ Garlic Sauce (Combo Platter)', 8.29)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('General Tso\'s Chicken (Combo Platter)', 8.29)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sesame Chicken (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Pork w/ Mixed Vegetable (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Pork w/ Garlic Sauce (Combo Platter)', 8.29)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Pepper Steak w/ Onion (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Mongolian Beef (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Beef w/ Broccoli (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Beef w/ Mixed Vegetable (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Beef w/ Garlic Sauce (Combo Platter)', 8.29)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Lobster Sauce (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Broccoli (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Mixed Vegetable (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Cashew Nuts (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Garlic Sauce (Combo Platter)', 8.29)
        .setSpicy(true).setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Mixed Vegetable (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Teriyaki Chicken (Combo Platter)', 8.29)
        .setServingOptions(2).setAddOns(...addOnOptions).build())